"use client"

import { useEffect, useState } from "react"
import { ref, onValue,set,serverTimestamp } from "firebase/database"
import { db } from "../Firebase/firebase-config"
import { auth } from "../Firebase/firebase-config"
import { useNavigate } from "react-router-dom"
import "./partnerStyle.css"
import { LogOut } from "lucide-react"

export default function ProfileDialog({
  open,
  onOpenChange,
  profile,
  mainUserId,   
  title = "Partner Profile"
}) {
  const [mainUserInfo, setMainUserInfo] = useState({
    company_name: "Loading...",
    gstin: "Loading...",
    pan: "Loading..."
  })
  const navigate = useNavigate()
  const [showConfirm, setShowConfirm] = useState(false)

  useEffect(() => {
    if (!open || !mainUserId) {
      setMainUserInfo({ company_name: "No access", gstin: "", pan: "" })
      return
    }

    const mainUserRef = ref(db, `profileDashboard/${mainUserId}`)
    const unsubscribe = onValue(mainUserRef, (snap) => {
      if (snap.exists()) {
        const data = snap.val()
        setMainUserInfo({
          company_name: data.company_name || "Main Business",
          gstin: data.gstin || "N/A",
          pan: data.pan || "N/A"
        })
      } else {
        setMainUserInfo({ company_name: "Account Not Found", gstin: "", pan: "" })
      }
    })

    return () => unsubscribe()
  }, [open, mainUserId])

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onOpenChange(false)
    }
    if (open) {
      document.body.style.overflow = "hidden"
      window.addEventListener("keydown", onKey)
    }
    return () => {
      document.body.style.overflow = "unset"
      window.removeEventListener("keydown", onKey)
    }
  }, [open, onOpenChange])
  const handleLogoutClick = () => {
    setShowConfirm(true)
  }

  const handleYes = async () => {
  try {
    const partnerUid = auth.currentUser?.uid
    if (partnerUid) {
      await set(ref(db, `onlineStatus/partners/${partnerUid}`), serverTimestamp())
    }

    localStorage.removeItem("partnerMainUserId") // Optional, keep if needed

    await auth.signOut()
    navigate("/partner-login", { replace: true })
  } catch (err) {
    console.error("Logout error:", err)
    navigate("/partner-login", { replace: true })
  } finally {
    setShowConfirm(false)
  }
}
  const handleNo = () => {
    setShowConfirm(false)
  }

  const rows = [
    { label: "Name", value: profile?.name || "Partner" },
    { label: "Email", value: profile?.email || "N/A" },
    { label: "Role", value: "Partner (Viewer)" },
    { label: "Company", value: mainUserInfo.company_name },
    { label: "GSTIN", value: mainUserInfo.gstin },
    { label: "PAN", value: mainUserInfo.pan },
  ]

  if (!open) return null

  return (
    <div className="ps-dialog-backdrop" onClick={() => onOpenChange(false)}>
      <div className="ps-profile-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-glow"></div>

        <div className="ps-dialog-header">
          <div className="header-avatar">
            {profile?.name?.[0]?.toUpperCase() || "P"}
          </div>
          <h2 className="ps-modal-title">{title}</h2>
          <p className="ps-subtitle">
            You are a partner of <strong>{mainUserInfo.company_name}</strong>
          </p>
        </div>

        <div className="ps-dialog-body">
          <div className="profile-grid">
            {rows.map((row) => (
              <div key={row.label} className="profile-row">
                <span className="profile-label">{row.label}</span>
                <span className="profile-value">{row.value}</span>
              </div>
            ))}
          </div>

        </div>
        <button
          onClick={handleLogoutClick}
          className="partner-footer-btn ps-mobile-btn "
        >
          <LogOut className="w-4 h-4 mt-2" />
          <span className="mt-2">Logout</span>
        </button>
        {showConfirm && (
          <div className="ps-confirm-overlay">
            <div className="ps-confirm-box">
              <h3 className="ps-confirm-title">Confirm Logout</h3>
              <p className="ps-confirm-message">
                Are you sure you want to logout?
              </p>

              <div className="ps-confirm-actions">
                <button className="ps-confirm-btn ps-confirm-no" onClick={handleNo}>
                  No
                </button>
                <button className="ps-confirm-btn ps-confirm-yes" onClick={handleYes}>
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="ps-dialog-actions">
          <button className="ps-btn ps-btn-primary" onClick={() => onOpenChange(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}